import * as React from 'react';
import classnames from 'classnames';

export interface ITabComponentProps {
    baseClassName: string;
    children?: React.ReactElement<typeof TabPage>[] | React.ReactElement<typeof TabPage>;
}

export interface ITabPageProps {
    baseClassName: string;
    id: string;
    title: string;
    isActive?: boolean;
    index?: number;
}

const TabPage: React.FC<ITabPageProps> = ({ baseClassName, id, title, isActive, index, children }) => {
    return (
        <section
            className={`${baseClassName}__tab-component__content-container`}
            role='tabpanel'
            id={`section-${id}`}
            aria-labelledby={`tab-${id}`}
            hidden={!isActive}
        >
            <h2 className='sr-only'>{title}</h2>
            <div className={`${baseClassName}__tab-component__content`}>
                {children}
            </div>
        </section>
    );
};

const TabComponent: React.FC<ITabComponentProps> = (props) => {
    const { baseClassName, children } = props;

    const [activeTab, setActiveTab] = React.useState(0);

    return (
        <div className={`${baseClassName}__tab-component`} id='product-tabs'>
            <div className={`${baseClassName}__tab-component__tabs`} role='tablist' aria-label='Product sections'>
                {React.Children.map(children, (child, index) => {
                    const props = (child as React.ReactElement).props as ITabPageProps;

                    return (
                        <button
                            className={classnames(`${baseClassName}__tab-component__tab`, { active: activeTab === index })}
                            role='tab'
                            id={`tab-${props.id}`}
                            aria-controls={`section-${props.id}`}
                            aria-selected={activeTab === index}
                            tabIndex={activeTab === index ? 0 : -1}
                            type='button'
                            data-tab={props.id}
                            onClick={(e) => {
                                setActiveTab(index);
                                // Make sure element is fully in view when clicked
                                const target = e.currentTarget;
                                target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                            }}
                        >
                            {props.title}
                        </button>
                    );
                })}
            </div>
            {React.Children.map(children, (child, index) => {
                return React.cloneElement(child as React.ReactElement, { isActive: activeTab === index, index });
            })}
        </div>
    );
};

export default TabComponent;
export { TabPage };
